<template>
  <span class="wrapper" v-if="params.node.rowPinned !== 'bottom'">
    <span v-tooltip.bottom="params.value">
      <i v-if="hasReceipt"
         class="fas fa-camera" style="color: #4A90E2;" />
      {{ params.value }}
    </span>
  </span>
</template>

<script>
  export default {
    computed: {
      hasReceipt() {
        return this.params.data && this.params.data.Receipt !== null
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/_modules/Programs/Card-transactions/ReconciliationStatus.vue